import React from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';

import { NavMenu, NwNavIcon } from '@components/_LayoutComponents/Header/NwHeaderUI';

import { getNavClassName, getNavMenuMode } from './NwNavUtils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const NwNavBarArt = ({ current, drawer, handleChangeOpenKeys, handleClick, isLoaded, openKeys }) => {
    const layoutContext = useLayoutContext();
    const { breakpoints } = layoutContext;

    const navItems = [
        // dashboard temporaneamente fuori dal menu: l'area parte dal website
        //{ key: '/art', label: 'Dashboard', disabled: !isLoaded },
        {
            key: '/menu-website',
            label: 'Website',
            popupClassName: 'main-nav-submenu',
            disabled: !isLoaded,
            onTitleClick: () => handleClick({ key: '/art/website' }),
            children: [
                {
                    type: 'group',
                    key: '/menu-tools-website',
                    label: (
                        <span className="submenu-title-wrapper">
                            <NwNavIcon icon={byPrefixAndName.fasl['bolt']} />
                            Website
                        </span>
                    ),
                    children: [
                        {
                            key: '/art/website',
                            label: (
                                <div className="nw-main-nav-subitems">
                                    <NwNavIcon icon={byPrefixAndName.fasl['browser']} />
                                    Website Structure
                                </div>
                            ),
                        },
                    ],
                },
            ],
        },
        { key: '/art/news', label: 'News', disabled: !isLoaded },
        { key: '/art/articles', label: 'Articles', disabled: !isLoaded },
        { key: '/art/galleries', label: 'Galleries', disabled: !isLoaded },
        { key: '/art/uploads', label: 'Uploads', disabled: !isLoaded },
        { key: '/art/model-contents', label: 'Model Contents', disabled: !isLoaded },
    ];

    const keysWithSubmenus = navItems.filter((item) => item.children).map((item) => item.key);

    return (
        <NavMenu
            className={getNavClassName(breakpoints, navItems.length)}
            inlineIndent={10}
            items={navItems}
            mode={getNavMenuMode(drawer, breakpoints)}
            onClick={handleClick}
            onOpenChange={(k) => handleChangeOpenKeys(k, keysWithSubmenus)}
            openKeys={openKeys}
            selectedKeys={[current]}
        />
    );
};

export default NwNavBarArt;
